import type { LinearSubstep } from "~/Configurators/Linear/models";

export const fetchSimpleSubstepValue = (step: LinearSubstep | undefined) => {
  if (!step || step.selectedTile === null) {
    return null;
  }
  const allTiles = [...step.tiles];
  step.groupedTiles?.forEach((group) => allTiles.push(...group.tiles));
  const selectedTile = allTiles[step.selectedTile];
  return selectedTile.name;
};
